import { render } from "./ProductTable.vue?vue&type=template&id=99de47d4&scoped=true"
import script from "./ProductTable.vue?vue&type=script&lang=js"
export * from "./ProductTable.vue?vue&type=script&lang=js"

import "./ProductTable.vue?vue&type=style&index=0&id=99de47d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99de47d4"]])

export default __exports__